import { CategorysService, ProductsService, NewsService } from "@/common/api.service";
import {
  FETCH_CATEGORIES,
  FETCH_NEW_PRODUCTS,
  FETCH_HOT_PRODUCTS,
  FETCH_LATEST_NEWS
} from "./actions.type";
import {
  FETCH_START,
  FETCH_END,
  SET_CATEGORIES,
  SET_NEW_PRODUCTS,
  SET_HOT_PRODUCTS,
  SET_LATEST_NEWS
} from "./mutations.type";

const initHotProducts = [
  {
    "modelNo": null, 
    "oldPrice":0, 
    "price": 0, 
    "package": null, 
    "image": "", 
    "quantity": 0, 
    "name": "", 
    "brandName": null
  },
  {
    "oldPrice":0, 
    "price": 0, 
    "package": null, 
    "image": "", 
    "quantity": 0, 
    "name": "", 
    "brandName": null
  },
  {
    "oldPrice":0, 
    "price": 0, 
    "package": null, 
    "image": "", 
    "quantity": 0, 
    "name": "", 
    "brandName": null
  },
  {
    "oldPrice":0, 
    "price": 0, 
    "package": null, 
    "image": "", 
    "quantity": 0, 
    "name": "", 
    "brandName": null
  },
  {
    "oldPrice":0, 
    "price": 0, 
    "package": null, 
    "image": "", 
    "quantity": 0, 
    "name": "", 
    "brandName": null
  },
  {
    "oldPrice":0, 
    "price": 0, 
    "quantity": 0, 
    "name": "", 
    "brandName": null
  },
  {
    "oldPrice":0, 
    "price": 0, 
    "quantity": 0, 
    "name": "", 
    "brandName": null
  },
  {
    "oldPrice":0, 
    "price": 0, 
    "quantity": 0, 
    "name": "", 
    "brandName": null
  },
  {
    "oldPrice":0, 
    "price": 0, 
    "quantity": 0, 
    "name": "", 
    "brandName": null
  },
  {
    "oldPrice":0, 
    "price": 0, 
    "quantity": 0, 
    "name": "", 
    "brandName": null
  },
  {
    "oldPrice":0, 
    "price": 0, 
    "quantity": 0, 
    "name": "", 
    "brandName": null
  }
];
const state = {
  hotProducts: initHotProducts,
  categories: [],
  newProducts: [],
  latestNews: [],
  isLoadingHome: true
};

const getters = {
  isLoadingHome(state) {
    return state.isLoadingHome;
  },
  newProducts(state) {
    return state.newProducts;
  },
  categories(state) {
    return state.categories;
  },
  hotProducts(state) {
    return state.hotProducts;
  },
  latestNews(state) {
    return state.latestNews;
  }
};

const actions = {
  [FETCH_CATEGORIES]({ commit }) {
    return CategorysService.getAll()
      .then(({ data }) => {
        commit(SET_CATEGORIES, data.result.items);
      })
      .catch(error => {
        throw new Error(error);
      });
  }, [FETCH_NEW_PRODUCTS]({ commit }) {
    return ProductsService.getNews(
      "Sorting=CreationTime&SkipCount=0&MaxResultCount=5"
    )
      .then(({ data }) => {
        commit(SET_NEW_PRODUCTS, data.result.items);
      })
      .catch(error => {
        throw new Error(error);
      });
  }, [FETCH_HOT_PRODUCTS]({ commit }) {
    commit(FETCH_START);
    return ProductsService.getHots("Sorting=CreationTime")
      .then(({ data }) => {
        commit(FETCH_END);
        commit(SET_HOT_PRODUCTS, data.result.items);
      })
      .catch(error => {
        throw new Error(error);
      });
  }, [FETCH_LATEST_NEWS]({ commit }) {
    return NewsService.getAll(
      "Sorting=CreationTime&SkipCount=0&MaxResultCount=4"
    )
      .then(({ data }) => {
        commit(SET_LATEST_NEWS, data.result.items);
      })
      .catch(error => {
        throw new Error(error);
      });
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_START](state) {
    state.isLoadingHome = true;
  },
  [FETCH_END](state) {
    state.isLoadingHome = false;
  },
  [SET_NEW_PRODUCTS](state, products) {
    state.newProducts = products;
  },
  [SET_CATEGORIES](state, categories) {
    state.categories = categories;
  },
  [SET_HOT_PRODUCTS](state, products) {
    state.hotProducts = products;
  },
  [SET_LATEST_NEWS](state, news) {
    state.latestNews = news;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
